import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMessageLines = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M11.25 4.5C11.6562 4.5 12 4.84375 12 5.25C12 5.6875 11.6562 6 11.25 6H4.75C4.3125 6 4 5.6875 4 5.25C4 4.84375 4.3125 4.5 4.75 4.5H11.25ZM8.25 7.5C8.65625 7.5 9 7.84375 9 8.25C9 8.6875 8.65625 9 8.25 9H4.75C4.3125 9 4 8.6875 4 8.25C4 7.84375 4.3125 7.5 4.75 7.5H8.25ZM14 0C15.0938 0 16 0.90625 16 2V11.0312C16 12.125 15.0938 13.0312 14 13.0312H9.5L5.59375 15.9375C5.34375 16.125 5 15.9375 5 15.6562V13.0312H2C0.875 13.0312 0 12.125 0 11.0312V2C0 0.90625 0.875 0 2 0H14ZM14.5 11.0312V2C14.5 1.75 14.25 1.5 14 1.5H2C1.71875 1.5 1.5 1.75 1.5 2V11.0312C1.5 11.2812 1.71875 11.5312 2 11.5312H6.5V13.4062L9 11.5312H14C14.25 11.5312 14.5 11.2812 14.5 11.0312Z",
		fill: "#90A4AE"
	})]
});
const ForwardRef = forwardRef(SvgMessageLines);
export { ForwardRef as ReactComponent };
